import { makeStyles } from "@mui/styles";
import color from "@definitions/mui/color";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "24px",
    marginBottom: 20,
  },
  backButton: {
    color: color.primary.main,
    display: "flex",
    alignItems: "center",
    gap: 8
  }
}));

export default useStyles;